import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";

export class DjPsychoXKnob extends PIXI.Container implements StageLayer {

    private HAND_ANIMATION_NAMES: string[] = ["Tweak", "Tweak_Devil", "Tweak_Mutant", "Tweak_Robot"];

    private _symbol: PIXI.spine.Spine;
    private _flyMulti: PIXI.BitmapText;
    private _hand: PIXI.spine.Spine;
    private _transform: TimelineSprite;
    private _handLoop: TimelineLite;
    private _handAnimSelected: string = "";

    constructor() {
        super();
        this.name = "DjPsychoXKnob";

        this.init();
    }

    public playSymbolAnimation(x: number, y: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            toX: number = 630,
            toY: number = 182;

        this._symbol.position.set(x + DjPsycho.reelViewX, y + DjPsycho.reelViewY);
        this._flyMulti.position = this._symbol.position;

        tl.add([
            () => {
                this._symbol.visible = true;
            },
            DjPsycho.createTimelineForAnimation(this._symbol, 0, "X_Knob_Attention", false)
        ], 0);

        tl.addLabel("startFly", (18 / 30));
        tl.add([
            () => {
                this._flyMulti.scale.set(1);
                this._flyMulti.visible = true;
            },
            DjPsycho.miniCollectors.flyMultiToTotalMultiplier()
        ], "startFly");
        tl.to(this._flyMulti, {
            duration: 0.5,
            x: toX,
            y: toY
        }, "startFly");
        tl.to(this._flyMulti.scale, {
            duration: 0.5,
            x: 0.3,
            y: 0.3,
            onComplete: () => {
                this._flyMulti.visible = false;
            }
        }, "startFly");

        tl.add(() => {
            this._symbol.visible = false;
            this._symbol.state.clearTracks();
        });

        return tl;
    }

    public playHandAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            handAnimName: string = ArrayHelper.getRandomValue(this.HAND_ANIMATION_NAMES);

        this._handAnimSelected = handAnimName;

        tl.add([
            () => {
                this._hand.visible = true;
            },
            DjPsycho.createTimelineForAnimation(this._hand, 0, handAnimName + "_In", false)
        ]);
        tl.add(() => {
            this._hand.autoUpdate = true;
            this._hand.state.setAnimation(0, handAnimName + "_Loop", true);
        });

        return tl;
    }

    public playTransformAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add([
            () => {
                if (this._handLoop) {
                    this._handLoop.pause();
                    this._handLoop.kill();
                }
                this._hand.state.clearTracks();

                this._transform.position = this._symbol.position;
            },
            this._transform.getAnimationAutoShowHide(true, true),
            DjPsycho.createTimelineForAnimation(this._hand, 0, this._handAnimSelected + "_Out", false)
        ]);
        tl.add(() => {
            this._hand.visible = false;

            this._handAnimSelected = "";
        });

        return tl;
    }

    private init(): void {
        this._symbol = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("xKnob"));
        this._symbol.visible = false;

        this._flyMulti = new PIXI.BitmapText("x1", {
            fontName: DjPsychoGameAssets.BITMAP_FONT_TOTAL_MULTIPLIER,
            fontSize: 40
        });
        this._flyMulti.visible = false;
        this._flyMulti.anchor = new PIXI.Point(0.5, 0.5);

        this._hand = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("xKnobHand"));
        this._hand.visible = false;
        this._hand.position.set(633, 180);

        let transformTextures: PIXI.Texture[] = DjPsycho.assetLoader.getTextures("C_Wild_Transform/C_Wild_Transform_");
        transformTextures = transformTextures.concat(DjPsycho.assetLoader.getTextures("Xs_Wild_Transform/Xs_Wild_Transform_").slice(transformTextures.length));
        this._transform = new TimelineSprite(transformTextures);
        this._transform.hide();
        this._transform.anchor.set(0.5);
        this._transform.scale.set(2);

        this.addChild(this._symbol, this._flyMulti, this._hand, this._transform);
    }
}